import React from 'react';
import { Box, Typography } from '@mui/material';
import { ScreenWarningContainer } from './ScreenSizeWarning.styles';
import { ReactComponent as VeernyIcon } from '../../assets/veerny-icon.svg';
import { Trans } from 'react-i18next';

const ScreenSizeWarning: React.FC = () => {
  return (
    <ScreenWarningContainer>
      <Box sx={{ marginBottom: '19px', width: '42px', height: '50px', flexShrink: 0 }}>
        <VeernyIcon width="100%" height="100%" />
      </Box>
      <Typography variant="h1" align="center" sx={{ lineHeight: 1.3 }}>
        {/* the <br/> lives in the translation, so each language decides where to break */}
        <Trans i18nKey="screenSize.title" />
      </Typography>
      <Typography variant="body2" align="center" sx={{ marginTop: 1, lineHeight: 1.3 }}>
        <Trans i18nKey="screenSize.hint" />
      </Typography>
    </ScreenWarningContainer>
  );
};

export default ScreenSizeWarning;
